/* This example requires Tailwind CSS v2.0+ */
import {
  AnnotationIcon,
  MailIcon,
  UserAddIcon,
} from "@heroicons/react/outline";
import {
  LightningBoltIcon,
  UsersIcon,
  ViewGridIcon,
} from "@heroicons/react/solid";
import React, { Component } from "react";
import Crops from "../../assets/crops.png";
import Financial from "../../assets/financial.png";

const types = [
  {
    id: 1,
    name: "Farming Sponsorship",
    description:
      "Connecting corporates' sponsorship to B40 groups for crop seedlings and/or plantation tools/infrastructure",
    icon: ViewGridIcon,
  },
  {
    id: 2,
    name: "Marketplace",
    description:
      "Connecting crops planted by B40 groups to retail-chained hypermarkets to create more market access and opportunies for B40 groups to generate revenue",
    icon: UsersIcon,
  },
  {
    id: 3,
    name: "Financial Education",
    description:
      "Connecting B40 groups to Hong Leong Financial services such as applying for equipment loan in order to allow B40 groups to innovate and increase their revenue",
    icon: LightningBoltIcon,
  },
];

const Home = [
  {
    id: 1,
    name: "Register and apply for farming incentives",
    description:
      "Anyone within the B40 community can register an account to start farming. Financial incentives from corporates sponsorship are available to kick start your journey.",
    icon: UserAddIcon,
  },
  {
    id: 2,
    name: "Sell from available marketplace list",
    description:
      "Ubi App helps to connect your crops to retail-chained hypermarkets to provide market opportunities and access to you",
    icon: MailIcon,
  },
  {
    id: 3,
    name: "Sustainable Investment",
    description:
      "Track your revenue and learn from educational resources provided by Hong Leong Bank to understand how do you leverage on their services to scale your business",
    icon: AnnotationIcon,
  },
];

export default class Content extends Component {
  render() {
    return (
      <div className="py-16 bg-gray-50 overflow-hidden lg:py-24">
        <div className="relative max-w-md sm:max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
          <svg
            className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
            width={404}
            height={784}
            fill="none"
            viewBox="0 0 404 784"
            aria-hidden="true"
          >
            <defs>
              <pattern
                id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={784}
              fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
            />
          </svg>

          <div className="relative">
            <h2 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Empowering B40, While Sustaining Carbon Reduction
            </h2>
            <p className="mt-4 max-w-3xl mx-auto text-center text-lg text-gray-500">
              Unlike other community farms, Ubi links corporates to push for
              decreasing carboon footprint by supporting the infrastructure to
              the community, helps them to sell crops and generate income.
            </p>
          </div>

          <div className="relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="relative">
              <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
                Services of Ubi App
              </h3>
              <p className="mt-3 text-lg text-gray-500">
                We are connecting B40 with corporate, growth short-terms crops
                and generate income for investment through carbon reduction.
              </p>

              <dl className="mt-10 space-y-10">
                {types.map((item) => (
                  <div key={item.id} className="relative">
                    <dt>
                      <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                        <item.icon className="h-6 w-6" aria-hidden="true" />
                      </div>
                      <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                        {item.name}
                      </p>
                    </dt>
                    <dd className="mt-2 ml-16 text-base text-gray-500">
                      {item.description}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>

            <div className="mt-10 -mx-4 relative lg:mt-0" aria-hidden="true">
              <svg
                className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden"
                width={784}
                height={404}
                fill="none"
                viewBox="0 0 784 404"
              >
                <defs>
                  <pattern
                    id="ca9667ae-9f92-4be7-abcb-9e3d727f2941"
                    x={0}
                    y={0}
                    width={20}
                    height={20}
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={4}
                      height={4}
                      className="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  width={784}
                  height={404}
                  fill="url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)"
                />
              </svg>
              <img
                className="relative mx-auto rounded"
                width={490}
                src={Financial}
                alt=""
              />
            </div>
          </div>

          <svg
            className="hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12"
            width={404}
            height={784}
            fill="none"
            viewBox="0 0 404 784"
            aria-hidden="true"
          >
            <defs>
              <pattern
                id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={784}
              fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
            />
          </svg>

          <div className="relative mt-12 sm:mt-16 lg:mt-24">
            <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="lg:col-start-2">
                <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
                  How Does Ubi App Works
                </h3>
                <p className="mt-3 text-lg text-gray-500">
                  If you are a corporate who is keen to sponsor Ubi App or B40
                  community , feel free to join in Ubi family.
                </p>

                <dl className="mt-10 space-y-10">
                  {Home.map((item) => (
                    <div key={item.id} className="relative">
                      <dt>
                        <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                          <item.icon className="h-6 w-6" aria-hidden="true" />
                        </div>
                        <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                          {item.name}
                        </p>
                      </dt>
                      <dd className="mt-2 ml-16 text-base text-gray-500">
                        {item.description}
                      </dd>
                    </div>
                  ))}
                </dl>
              </div>

              <div className="mt-10 -mx-4 relative lg:mt-0 lg:col-start-1">
                <svg
                  className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden"
                  width={784}
                  height={404}
                  fill="none"
                  viewBox="0 0 784 404"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="e80155a9-dfde-425a-b5ea-1f6fadd20131"
                      x={0}
                      y={0}
                      width={20}
                      height={20}
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x={0}
                        y={0}
                        width={4}
                        height={4}
                        className="text-gray-200"
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect
                    width={784}
                    height={404}
                    fill="url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)"
                  />
                </svg>
                <img
                  className="relative mx-auto rounded"
                  width={320}
                  src={Crops}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
